import React from 'react';

import Payment from '../../types/payment';
import UnappliedPaymentCardListItem from './UnappliedPaymentCardListItem';
import { EmptyStateCard, CardList } from '../InvoiceCardList/InvoiceCardList';

interface Props {
  payments: Payment[];
}

const UnappliedPaymentCardList = ({ payments }: Props) => {
  const cards = payments.map(payment => (
    <UnappliedPaymentCardListItem key={payment.id} payment={payment} />
  ));

  const emptyState = (
    <EmptyStateCard>There are currently no unapplied payments on your account.</EmptyStateCard>
  );

  return <CardList>{cards.length === 0 ? emptyState : cards}</CardList>;
};

export default UnappliedPaymentCardList;
